<template>
  <div id="app">
    <TopBar />
    <router-view />
    <FootBar />
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import FootBar from '@/components/FootBar.vue'

export default {
  components: {
    TopBar,
    FootBar
  }
}
</script>
